/* @ngInject */
function BackOfficeSettingsController ($scope, $rootScope) {
  $scope.userNotAuthorized = false

  activate()
  function activate () {
    $rootScope.getUser().then(user => {
      $scope.userNotAuthorized = !$rootScope.isUserSysAdmin(user)
    })
  }
}

export { BackOfficeSettingsController }
